import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { TaskProcessContext } from '../shared/task-process-context.class';
import { DesktopTPPRightColumnService } from './desktop-tpp-right-column.service';

@Component({
  selector: 'app-desktop-tpp-right-column',
  templateUrl: './desktop-tpp-right-column.component.html',
  styleUrls: ['./desktop-tpp-right-column.component.scss'],
})
export class DesktopTPPRightColumnComponent implements AfterViewInit, OnDestroy {
  @Input() taskProcessContext: TaskProcessContext;
  @Input() engagement = false;

  // see https://angular.io/guide/dynamic-component-loader
  // and https://stackoverflow.com/questions/37450805/what-is-the-read-parameter-in-viewchild-for
  @ViewChild('pseudoModalContainer', { read: ViewContainerRef })
  pseudoModalContainerRef: ViewContainerRef;

  hasPseudoModal = false;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private desktopTPPRightColumnService: DesktopTPPRightColumnService
  ) {}

  ngAfterViewInit() {
    this.desktopTPPRightColumnService.setRightColumnComponent(this);
  }

  ngOnDestroy() {
    this.desktopTPPRightColumnService.setRightColumnComponent(null);
  }

  displayPseudoModal(component, componentInputs) {
    this.clearPseudoModal();
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const componentRef = this.pseudoModalContainerRef.createComponent(componentFactory);
    const instance: any = componentRef.instance;
    if (componentInputs) {
      for (const key of Object.keys(componentInputs)) {
        instance[key] = componentInputs[key];
      }
    }
    this.hasPseudoModal = true;
    if (instance.ionViewDidEnter) {
      // Hopefully Angular only needs one tick to have the DOM built and displayed
      setTimeout(() => instance.ionViewDidEnter());
    }
  }

  clearPseudoModal() {
    this.hasPseudoModal = false;
    this.pseudoModalContainerRef.clear();
  }
}
